import React, { useMemo } from 'react';
import { RapportMall } from '../../../../../../BaseComponents/RapportMall/RapportMall';
import { BusinessDataFormContext } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';

interface IProps {}

export const BusinessDataFormRapportMall: React.FC<IProps> = props => {
  const formContext = React.useContext(BusinessDataFormContext);
  const setMall = (mall: string) => {
    formContext?.update([
      {
        operation: 'OwnFields',
        values: { PdfJson: mall.replaceAll('\n', '\r\n') },
      },
    ]);
  };

  const template = useMemo(() => {
    const template = formContext?.formState.currentValues.PdfJson
      ? JSON.parse(formContext?.formState.currentValues.PdfJson)
      : null;
    return template;
  }, [formContext?.formState.currentValues.PdfJson]);

  // If the template is an array, we don't support multiple templates yet.
  if (Array.isArray(template)) {
    return (
      <div>
        Rapportmallen består av flera mallar. Det saknas stöd för detta i
        nuläget. Vänligen välj en annan rapport
      </div>
    );
  }

  return (
    <RapportMall
      title={formContext?.formState.currentValues.REPORTNAME}
      settings={formContext?.formState?.currentValues?.LAYOUTOPTIONS?.split(
        ';'
      ).reduce((settings: any, option: string) => {
        const [key, value] = option.split('=');
        if (key && value) {
          settings[key] = value;
        }
        return settings;
      }, {})}
      mall={formContext?.formState.currentValues.PdfJson}
      setMall={setMall}
    />
  );
};
